<div class="container-fluid h-100">
    <div class="row">
        <div class="col">
            <canvas id="mainmenu-webgl"></canvas>
            <ul class="mainmenu">
                <li data-href="leistungen"><span class="menu-scramble" data-text="LEISTUNGEN">&nbsp;</span></li>
                <li data-href="portfolio"><span class="menu-scramble" data-text="REFERENZEN">&nbsp;</span></li>
                <li data-href="technology"><span class="menu-scramble" data-text="TECHNOLOGIE">&nbsp;</span></li>
                <li data-href="about"><span class="menu-scramble" data-text="ÜBER">&nbsp;</span></li>
                <li data-href="contact"><span class="menu-scramble" data-text="KONTAKT">&nbsp;</span></li>
            </ul>
        </div>
    </div>
</div>
